<template>
    <div class="device-type-manange relative">
        <div class="buttons">
            <el-button @click="goSort">保存排序</el-button>
            <el-button :id="'systemUserAdd'" @click="goAdd">新增</el-button>
        </div>
        <!-- 表单开始 -->

        <!-- 表单结束 -->
        <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id"
            border :default-expand-all="false"
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            <el-table-column prop="action_name" label="权限名称" align="left" label-class-name="label"></el-table-column>
            <el-table-column prop="module_name" label="对应功能" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="status_text" label="是否隐藏" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="id" label="权限ID" align="center" label-class-name="label"></el-table-column>
            <el-table-column label="排序序号" align="center" label-class-name="label">
                <template scope="scope">
                    <el-input v-model="scope.row.sort" min="0"></el-input>
                </template>
            </el-table-column>
            <el-table-column
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button :id="'systemUserEdit'" @click="goAdd(scope.row)" type="text">
                    添加子权限
                </el-button>
                <el-button :id="'systemUserEdit'" @click="goEdit(scope.row)" type="text">
                    编辑
                </el-button>
<!--                <el-button :id="'systemUserDel'" @click="del_menu(scope.row)" type="text">-->
<!--                    删除-->
<!--                </el-button>-->
            </el-table-column>
        </el-table>


    </div>
</template>
<script>
    import {check} from "@/utils/checkData";
    import {getUserInfos} from '@/utils/userInfos';

    export default {
        data() {
            return {
                search_data: null,
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                //删除确认
                deleteDialogVisible: false,
                delete_id: '',
                is_submit: false,
            };
        },
        mounted() {
            // 获取权限列表
            this.getList();
        },
        methods: {
            // 获取所有设备类型
            getList() {
                let params = {
                    servername: 'Ruyi_AdminSystemServices',
                    method: 'getAdminAction',
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                        res.data.data.list[i].status_text = res.data.data.list[i].status == 1 ? '显示' : '隐藏'
                        if (res.data.data.list[i].children) {
                            for (var j = 0; j < res.data.data.list[i].children.length; j++) {
                                res.data.data.list[i].children[j].status_text = res.data.data.list[i].children[j].status == 1 ? '显示' : '隐藏'

                                if (res.data.data.list[i].children[j].children) {
                                    for (var k = 0; k < res.data.data.list[i].children[j].children.length; k++) {
                                        res.data.data.list[i].children[j].children[k].status_text = res.data.data.list[i].children[j].children[k].status == 1 ? '显示' : '隐藏'
                                    }
                                }
                            }
                        }
                    }
                    this.tableData = res.data.data.list;
                });
            },
            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },
            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },
            // 排序
            goSort() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;

                let _that = this
                let sortData = this.getSortData(this.tableData);

                let params = {
                    servername: 'Ruyi_AdminSystemServices',
                    method: 'reSortAdminAction',
                    params: {
                        sortData: sortData
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    this.$message({
                        type: "success",
                        message: '修改成功',
                        duration: 1500,
                    });
                    this.is_submit = false;
                    _that.getList();
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },
            // 跳转编辑页
            goEdit(data) {
                this.$router.push({
                    name: "adminActionEdit",
                    params: {
                        id: data.id,
                        parent_id: data.pid,
                        action_name: data.action_name,
                        status: data.status,
                        module_id: data.module_id,
                        sort: data.sort,
                    }
                });
            },

            // 跳转添加页
            goAdd(data) {
                if (data.pid) {
                    this.$router.push({name: "adminActionAdd", params: {parent_id: data.id}});
                } else {
                    this.$router.push({name: "adminActionAdd"});
                }
            },

            // 删除权限
            del_menu(val) {
                let message = '确定该删除该权限吗?';
                this.$confirm(message, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminSystemServices',
                        method: 'delAdminAction',
                        params: {
                            id: val.id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        this.$message.success('删除成功！');
                        this.getList();
                    });
                }).catch(() => {
                });
            },
            getSortData(data) {
                let res = [];
                let child = [];
                for (let i = 0; i < data.length; i++) {
                    res.push({
                        id: data[i].id,
                        sort: data[i].sort,
                    })
                    if (data[i].children) {
                        child = this.getSortData(data[i].children)
                        res = res.concat(child)
                    }
                }
                return res;
            },
        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";
</style>
